// Route publique "/sorties/:token" (lien "Mes sorties" d'un organisateur).
//
// Reconnaissance STRICTE, volontairement pas un startsWith() : exactement
// deux segments, le premier litteralement "sorties", le second conforme au
// format exact du jeton (32 caracteres base64url, cf.
// functions/src/services/userShareLinkService.js). Toute deviation (segment
// supplementaire, prefixe partiel, jeton mal forme) ne doit PAS matcher,
// pour ne jamais router un chemin voisin ou un id partiel vers la page
// publique par accident.
export const EVENTS_SHARE_TOKEN_PATTERN = /^[A-Za-z0-9_-]{32}$/;

export function matchOrganizerEventsSharePath(pathname) {
  const segments = String(pathname || "")
    .split("/")
    .filter((segment) => segment.length > 0);

  if (segments.length !== 2) {
    return null;
  }

  if (segments[0] !== "sorties") {
    return null;
  }

  const token = segments[1];
  return EVENTS_SHARE_TOKEN_PATTERN.test(token) ? token : null;
}

export function isOrganizerEventsSharePath(pathname) {
  return matchOrganizerEventsSharePath(pathname) !== null;
}
